import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { BsModalService } from 'ngx-bootstrap/modal';

import { CartAbandonmentWarningComponent } from './cart-abandonment-warning/cart-abandonment-warning.component';
import { CaseIdentifier } from './../shared/case-identifier';
import { CourtCase } from './../shared/court-case';
import { CivilSearchService } from '../civil/civil-search.service';
import { CivilIdentitySearchCase } from '../civil/civil-identity-search-case';
import { CivilCase } from '../civil/civil-case';
import { EventService } from '../shared/event.service';

@Injectable()
export class CartService {

  savedCases: CourtCase[] = [];
  selectedCaseIdentifiers: Set<CaseIdentifier> = new Set();
  private cartSizeChangeSource = new Subject<number>();
  cartSizeChanged$: Observable<number> = this.cartSizeChangeSource.asObservable();

  constructor(private civilSearchService: CivilSearchService,
              private eventService: EventService,
              private modalService: BsModalService) {
  }

  areAllSelected(): boolean {
     return this.savedCases.length === this.selectedCaseIdentifiers.size;
  }

  addCase(theCase: CourtCase): void {
    if (this.contains(theCase.getCaseIdentifier())) {
      return; // the case is already in the cart
    }

    // reload if necessary, then replace or push to the savedList
    if (theCase instanceof CivilIdentitySearchCase) {
      // first add the civil identity case
      this.savedCases.push(theCase);
      this.announceCartSizeChange();

      // then call to get normal Civil Case and replace the identity case
      this.civilSearchService.findByCaseIdentifier(theCase.getCaseIdentifier())
        .subscribe(
          civilCase => {
            // succeeded loading, replace with the new loaded normal case detail to the savedList
            const caseIndex = this.savedCases.findIndex((aCase) => theCase.getCaseIdentifier().equals(aCase.getCaseIdentifier()));
            if (caseIndex !== -1) {
              this.savedCases.splice(caseIndex, 1, civilCase);
            }
        },
        (errorMessage: string) => {
          // failed loading, logged the error
          console.log('Cart Service loading Civil Case for party case failed'  + errorMessage);
        });
    }  else {
      // normal civil case details, just push to the savedList
      this.savedCases.push(theCase);
      this.announceCartSizeChange();
    }
  }

  removeCase(theCase: CourtCase): void {
    for (let i = 0; i < this.savedCases.length; i++) {
        if (this.savedCases[i].getCaseIdentifier().equals(theCase.getCaseIdentifier())) {
            this.savedCases.splice(i, 1);
            this.announceCartSizeChange();
            break;
        }
    }
    this.selectedCaseIdentifiers.delete(theCase.getCaseIdentifier());
  }

  contains(caseIdentifier: CaseIdentifier) {
    for (let savedCase of this.savedCases) {
        if (savedCase.getCaseIdentifier().equals(caseIdentifier)) {
            return true;
        }
    }
    return false;
  }

  empty() {
    this.savedCases.length = 0;
    this.selectedCaseIdentifiers.clear();
    this.announceCartSizeChange();
  };

  selectCase(caseIdentifier: CaseIdentifier) {
    if (!this.isSelected(caseIdentifier)) {
       this.selectedCaseIdentifiers.add(caseIdentifier);
    }
  };

  deselectCase(caseIdentifier: CaseIdentifier) {
    this.selectedCaseIdentifiers.delete(caseIdentifier);
  };

  isSelected(caseIdentifier: CaseIdentifier) {
    let selectionFound = false;
    this.selectedCaseIdentifiers.forEach(function(caseId){
      if (!selectionFound && caseIdentifier.equals(caseId)) {
        selectionFound = true;
      }
    });

    return selectionFound;
  };

  isEmpty() {
    return this.savedCases.length === 0;
  };

  selectAll() {
    this.savedCases.forEach((savedCase) => this.selectedCaseIdentifiers.add(savedCase.getCaseIdentifier()));
  };

  deselectAll() {
    this.selectedCaseIdentifiers.clear();
  };

  getSelectedCases() {
    return this.savedCases.filter(savedCase => this.isSelected(savedCase.getCaseIdentifier()));
  };

  private announceCartSizeChange() {
    this.cartSizeChangeSource.next(this.savedCases.length);
  }

  /**
   * Creates a modal asking the user to abandon their cart, or navigate to the cart. The component in the modal
   * will actually handle the navigation to the cart should the user choose that action.
   * @return {Promise<boolean>} A Promise indicating whether the user wants to abandon their cart.
   */
  canCartBeAbandoned(): Promise<boolean> {
    const modalRef = this.modalService.show(CartAbandonmentWarningComponent, {backdrop: 'static', keyboard: false});
    return new Promise<boolean>((resolve, reject) => {
        modalRef.content.allowAbandonment$.subscribe(value => {
            resolve(value);
            modalRef.hide();
        });
        this.eventService.clearHistoryRequested$.subscribe(() => {
            resolve(false);
            modalRef.hide();
        });
     });
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/cart/cart.service.ts